import React from "react";
import { Badge, Button, Card, CardBody } from "reactstrap";
import { MatchContext } from "../providers/match";
import { Ienums } from "../utils/interface";
import { useNavigate } from "react-router-dom";
import { getMatchConfig } from "../utils/services/matchConfig";
import HostingRestrictionIcon from "../components/HostingRestrictionIcon";

function CardRoomItem(props) {
  const navigate = useNavigate();

  // state de imagem
  const [imageError, setImageError] = React.useState(false);

  // reseta o erro de imagem quando a foto do participante muda
  React.useEffect(() => {
    setImageError(false);
  }, [props?.allData?.picture]);

  async function getConfigError() {
    const params = new URLSearchParams(window.location.search);
    const res = await getMatchConfig(
      params.get("idEvent"),
      params.get("idPart"),
    );
    if (res?.message === "MATCH_CONFIG_FOUND") {
      return false;
    }
    if (
      res?.message === "MATCH_CONFIG_NOT_FOUND" ||
      res?.message === "EXISTS_NO_MATCH_GROUPS"
    ) {
      return true;
    }
  }
  const { t, matchConfig } = React.useContext(MatchContext);
  return (
    <div className="div-card-roomItem">
      <Card
        className="card-room-item-main"
        style={{
          width: "100%",
          borderLeft:
            props.status !== "N"
              ? `6px solid ${props.status === Ienums.COMPLETED ? "#34C38F" : "#F1B44C"}`
              : "",
        }}
      >
        <CardBody
          className="room-item-body"
          style={{ flexDirection: "column" }}
        >
          {props.status !== "N" ? (
            <>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              > */}
              <div className="room-item-icon" style={{ marginRight: 10 }} onClick={() => console.log(props.allData)}>
                {props?.allData?.picture && !imageError ? (
                  <img
                    src={props.allData.picture}
                    alt={props.name}
                    className="room-item-icon-picture"
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <i
                    className="fa-solid fa-user"
                    style={{ color: matchConfig?.colorBackground }}
                  />
                )}
              </div>
              <div className="room-item-info" style={{ textAlign: "center" }}>
                <span className="room-item-label">
                  {props.name}
                  {props?.hostingRestriction && (
                    <HostingRestrictionIcon
                      hostingRestriction={props?.hostingRestriction}
                      idiom={t}
                    />
                  )}
                </span>
              </div>
              {/* </div> */}

              {props.status === Ienums.PENDING_ACCEPT && (
                <Badge color="warning" className="room-item-badge">
                  <i className="fa-solid fa-clock room-item-badge-icon"></i>
                  {t("Pendente aceite")}
                </Badge>
              )}
              {props.status === Ienums.PENDING_SEND && (
                <Badge color="warning" className="room-item-badge text-wrap">
                  <i className="fa-solid fa-paper-plane room-item-badge-icon"></i>
                  {t("Pendente Envio da Solicitação")}
                </Badge>
              )}
              {props.status === Ienums.COMPLETED && (
                <Badge color="success" className="room-item-badge">
                  <i className="fa-solid fa-check room-item-badge-icon"></i>
                  {t("Concluído")}
                </Badge>
              )}
            </>
          ) : (
            <div className="room-item-add">
              <Button
                className="room-item-add-btn"
                onClick={async () => {
                  const errorConfig = await getConfigError();
                  if (errorConfig) {
                    const searchParams = window.location.search;
                    window.location.href = "/select" + searchParams;
                  } else {
                    navigate({
                      pathname: "/participants",
                      search: window.location.search,
                    });
                  }
                }}
                color="warning"
              >
                <i className="fa-solid fa-plus"></i>
              </Button>
              <span className="room-item-add-label">{t(props.name)}</span>
            </div>
          )}
        </CardBody>
      </Card>
      {props.status === Ienums.PENDING_SEND && (
        <div
          className="div-icon-delete"
          onClick={() => props.confirmDeleteUser(props.allData)}
        >
          <i className="bx bx-trash-alt" />
        </div>
      )}
    </div>
  );
}
export default CardRoomItem;
